// extracted by mini-css-extract-plugin
export default {"container":"aba-z","productName":"bba-z","price":"cba-z","dimensions":"dba-z"};